var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33196 1.859C9.61032 1.31356 10.3897 1.31356 10.668 1.859L12.5438 5.53453C12.7254 5.89043 13.0662 6.13805 13.4608 6.20081L17.5361 6.84895C18.1409 6.94513 18.3817 7.68635 17.949 8.11963L15.033 11.0394C14.7506 11.3221 14.6204 11.7228 14.6827 12.1174L15.3256 16.1935C15.421 16.7984 14.7905 17.2565 14.2447 16.9789L10.5668 15.1078C10.2106 14.9267 9.78936 14.9267 9.43323 15.1078L5.75529 16.9789C5.2095 17.2565 4.57898 16.7984 4.67439 16.1935L5.3173 12.1174C5.37955 11.7228 5.24937 11.3221 4.96701 11.0394L2.05102 8.11963C1.61829 7.68635 1.85913 6.94513 2.46388 6.84895L6.53916 6.20081C6.93376 6.13805 7.27459 5.89043 7.45622 5.53453L9.33196 1.859Z",
    stroke: "#FFDC00",
    strokeWidth: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.3e1e2f13c832c37e2c9ed1699bd4caed.svg";
export { ForwardRef as ReactComponent };